import checkFF from '@webapp-next/lib/feature-flag';
import { tabHighlight, showSideTeamStatusBar } from './helpers';
import { createWebappRoute } from '@/router/helpers';

export default [
  createWebappRoute({
    path: '/tasks',
    name: 'tasks-module',
    component: () => {
      console.log('ROUTER, tasks');

      if ($dt.objConfig.IsFreemium) {
        $dt.toggleFreemiumUpgradeModal('template-tasks');
        return false;
      }

      if ($dt.objConfig.IsSubscriptionPaused) {
        $dt.showPausedBusinessAccountModal();
        return false;
      }

      tabHighlight('tasks');
      showSideTeamStatusBar(!checkFF('usc-442-removes-team-panels'));

      /*
       * Load the placeholder plugin and apply it to the current employee controls.
       * The new controls that get created will have the main view apply it to them.
       *
       * @added by Theodore Raisis 18 Oct 2012
       * @modified by Caesar 1st, Nov, 2012
       */
      yepnope({
        test: Modernizr.input.placeholder,
        nope: 'js/_app/jquery.placeholder.js',
        complete: function() {
          if (jQuery().placeholder) {
            // config for name placeholders
            const objPlaceHolderConfigDefault = DP.utils.setPlaceHolder({
              placeholderCSS: {
                left: '5px',
                top: '-8px',
                width: '300px',
                height: '17px',
              },
            });
            // apply the plugin to the currently rendered controls
            $('input[placeholder]#task-searchbox').placeholder(
              objPlaceHolderConfigDefault
            );
          }
        },
      });

      $dttk.lazyInit(); // only initialising newsfeed on route navigate

      if (window.$dttk) {
        if ($dttk.blnInitialized) {
          $dttk.refresh();
        }
      }

      return {};
    },
  }),
];
